import React from 'react';
import { Link } from 'react-router';
import { NAV_PATH } from '@/router/constants';
import { useFaqDetail } from '@/pages/customer-support/faq/hook/useFaqDetail';

const FaqDetailPage = () => {
	const { faqDetailClickGoList } = useFaqDetail();
	return (
		<main id="sub" className="sub faq">
			<section id="" className="sub-content">
				<div className="sub-inner">
					<div className="board-wrap">
						{/*<!-- 임시 -->*/}
						<div className="board-detail faq">
							<div className="detail-head">
								<strong className="title">{/*<!-- title -->*/}</strong>
							</div>

							<div className="detail-body">
								<div className="text-box">{/*<!-- content -->*/}</div>
							</div>

							<div className="detail-foot">
								<ul>
									<li>
										<a href="" className="detail-next-btn">
											<i className="ico-board-up" aria-hidden="true"></i>
											다음글
											{/*<!-- [Dev] 가장 최신 목록인 경우 first class 추가 -->*/}
											<p className="title">{/*<!-- title -->*/}</p>
											{/*<!-- <p class="title first">새로운 기능이 추가되었습니다!</p> -->*/}
										</a>
									</li>
									<li>
										<a href="" className="detail-prev-btn">
											<i className="ico-board-down" aria-hidden="true"></i>
											이전글
											{/*<!-- [Dev] 가장 마지막 목록인 경우 last class 추가 -->*/}
											<p className="title">{/*<!-- title -->*/}</p>
										</a>
									</li>
								</ul>
							</div>
						</div>

						<aside className="faq-nav">
							<p className="faq-nav-title">
								<span id="faq_quick_title">전체</span>{' '}
								<Link to={NAV_PATH.CUSTOMER_SUPPORT.FAQ} className="faq-nav-more">
									더보기
								</Link>
							</p>
							<ul className="faq-nav-list">{/*<!-- import faq_detail.js -->*/}</ul>
						</aside>
					</div>

					<div className="button-group align-center">
						<button className="btn primary" onClick={faqDetailClickGoList}>
							목록
						</button>
					</div>
				</div>
			</section>
		</main>
	);
};

export default FaqDetailPage;
